import { Grid } from "@material-ui/core";
import { Button, Icon, Select, Tooltip } from "antd";
import TextEvents from "app/components/TextEvents";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { styles, useStyles } from "../ReportCommunicationProgramStyles";
import * as ReportAction from "app/actions/ReportCommunicationProgramAction";

function FilterScreen() {
  const [collapse, setCollapse] = useState(true);
  const dispatch = useDispatch();
  const classes = useStyles();

  const { idSubdirection } = useSelector((state) => state.Auth.employeeById);
  const {
    isLoadingCommunicationProgram,
    listCommunicationProgram,
    filter,
    pagination,
    isLoadExport,
  } = useSelector((state) => state.ReportCommunicationProgramAction);

  const data = {
    offset: 0,
    limit: pagination.pageSize,
    sortColumn: pagination.column,
    sortDir: pagination.order,
    idSubdirection: idSubdirection,
    idCommunicationProgram: filter.idCommunicationProgram,
  };

  const onlistCommunicationProgram = (key) => {
    dispatch(ReportAction.saveFilter({ idCommunicationProgram: key }));
    dispatch(ReportAction.clearGrid());
  };

  const search = () => {
    dispatch(ReportAction.getReportCommunicationProgramGrid(data));
  };

  const exportXls = () => {
      dispatch(ReportAction.exportXls(data))
  }

  const optionlistCommunicationProgram = listCommunicationProgram.map(
    (item) => (
      <Select.Option
        key={item.idCommunicationProgram}
        value={item.idCommunicationProgram}
      >
        {item.communicationProgramName}
      </Select.Option>
    )
  );

  return (
    <div>
      <div hidden={collapse}>
        <Grid container direction="row" spacing={2}>
          {/* <Grid item xs={6}> */}
          <Grid item md={6} lg={6} sm={6} xs={12}>
            <TextEvents
              text="Programa de comunicación:"
              color="darker"
              size="label"
              weight="medium"
            />
            <Select
              loading={isLoadingCommunicationProgram}
              placeholder="[Selecciona programa de comunicación]"
              showSearch
              onChange={onlistCommunicationProgram}
              style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
              optionFilterProp="Children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              mode="default"
            >
              {optionlistCommunicationProgram}
            </Select>
          </Grid>
        </Grid>
      </div>
      {/**Botones */}
      <div className={classes.container} style={styles.baseVerticalMargin}>
        {collapse ? (
          <Tooltip title={"Mostrar filtro"}>
            <Button
              className={classes.button}
              variant="contained"
              type="link"
              onClick={() => setCollapse(false)}
            >
              <Icon type="down" />
            </Button>
          </Tooltip>
        ) : (
          <Tooltip title={"Ocultar filtro"}>
            <Button
              className={classes.button}
              variant="contained"
              type="link"
              onClick={() => setCollapse(true)}
            >
              <Icon type="up" />
            </Button>
          </Tooltip>
        )}
        <Button
          className={classes.button}
          variant="contained"
          type="primary"
          onClick={() => search()}
        >
          Buscar
        </Button>
        <Button
          className={classes.button}
          loading={isLoadExport}
          variant="contained"
          type="primary"
          onClick={() => exportXls()}
        >
          Exportar
        </Button>
      </div>
    </div>
  );
}

export default FilterScreen;
